import { Badge, BadgeProps } from '@chakra-ui/react'
import { MemberRole } from 'src/features/member/types'

type Props = {
  role: MemberRole
  isPartner?: boolean
}

const roleDisplayText = (role: Props['role']): string => {
  if (role === 'Viewer') return '閲覧のみ'
  return role
}

const badgeStyle = (isPartner: boolean): BadgeProps => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: 'auto',
    minW: '28px',
    h: '18px',
    px: '4px',
    fontWeight: 'bold',
    textTransform: 'none',
    bg: isPartner ? 'gray.100' : 'gray.600',
    color: isPartner ? 'gray.700' : 'white',
  }
}

export const RoleBadge: React.FC<Props> = ({ role, isPartner = false }) => {
  return <Badge {...badgeStyle(isPartner)}>{roleDisplayText(role)}</Badge>
}
